import { useTranslation } from "react-i18next";
import { minutesToDecimalHours } from "@features/myinfo/lib/utils";
import { useQuery } from "@tanstack/react-query";
import { membershipQueries, reservationQueries } from "@app/config/queryFactory";

function formatMinutesToDisplay(
  minutes: number,
  t: (key: string, options?: { count?: number; hours?: number; minutes?: number }) => string,
): string {
  const hours = minutesToDecimalHours(minutes);
  return t("hours", { count: hours });
}

const Credits = () => {
  const { t } = useTranslation();

  const { data: membership } = useQuery(membershipQueries.membership());
  const { data } = useQuery({
    ...reservationQueries.remainingMinutes(),
    enabled: !!membership,
  });

  const monthlyMinutes = data?.monthly_minutes ?? 0;
  const remainingMinutes = data?.remaining_minutes ?? 0;

  return (
    <div className="rounded-8 border border-gray-200 bg-white p-4 md:max-w-[296px] max-w-full">
      <div className="flex flex-col gap-4">
        <div className="flex justify-between items-center text-body4 tracking-[-0.28px] ">
          <span className="text-gray-800">{t("monthlyCredits")}</span>
          <span className="font-semibold text-primary-500">{formatMinutesToDisplay(monthlyMinutes, t)}</span>
        </div>
        <div className="flex justify-between items-center text-body4 tracking-[-0.28px] ">
          <span className="text-gray-800">{t("creditsRemaining")}</span>
          <span className="font-semibold text-primary-500">{formatMinutesToDisplay(remainingMinutes, t)}</span>
        </div>
      </div>
    </div>
  );
};

export default Credits;
